import React from 'react';
import styles from './Feedback.module.css';

interface IComment {
    datetime: string,
    user: {
        name: string,
    },
    text: string,
}

interface IFeedbackItem {
    forOrder: {
        ofDate: string,
    },
    feedback: IComment,
    reply: IComment | null,
}


interface IFeedbackItemProps {
    item: IFeedbackItem,
}

function FeedbackItem(props: IFeedbackItemProps) {
    const { item } = props
    return <div className={styles.feedbackItem}>
        <div>
            <strong>{item.feedback.user.name}</strong>
            <span> {new Date(item.feedback.datetime).toLocaleDateString()} </span>
            <span className={styles.feedbackItemMeta}> (за заказ от {new Date(item.forOrder.ofDate).toLocaleDateString()}) </span>
        </div>
        <div><p className={styles.feedbackItemText}>{item.feedback.text}</p></div>
    </div>
}

export type IFeedbackItems = IFeedbackItem[]

interface IFeedbackProps {
    feedbackComments: IFeedbackItem[]
}

export default function Feedback(props: IFeedbackProps) {
    const { feedbackComments } = props
    return <div className={styles.feedbackBlock}>
        <h1>Обратная связь</h1>
        {
            feedbackComments.map((item, index) => {
                return <FeedbackItem item={item} key={index} />
            })
        }
    </div>
};
